import { Directive, Input, ElementRef, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { PrebootService } from '../services/preboot.service';
import { Subscription } from 'rxjs';
@Directive({
    selector: '[appIfStable]'
})
export class IfStableDirective implements OnInit, OnDestroy {

    private sub: Subscription;

    constructor(
        private element: ElementRef,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private prebootSvc: PrebootService
    ) {
        
    }

    ngOnInit() {
        this.sub = this.prebootSvc.transitionComplete.subscribe(stable => {
            this.updateView(stable);
        });
    }

    ngOnDestroy(): void {
        if (this.sub && !this.sub.closed) {
            this.sub.unsubscribe();
        }
    }

    private updateView(show: boolean) {
        if (show) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
